/**
 * URL of the SEPARATE platform-operator SPA (operator.html), served at
 * platform-admin.sentrysolutions.info in prod. The operator console was split out
 * of the customer bundle, so customer-app links to it are cross-app navigations
 * (the session cookie is shared across *.sentrysolutions.info, so no re-login).
 *
 * Override with VITE_OPERATOR_URL. In dev the operator SPA is only served at
 * /operator.html (Vite multi-page), so deep paths can't be linked directly there —
 * we fall back to the app root and let the operator navigate client-side.
 */
export function operatorAppUrl(path = ''): string {
  const base =
    (import.meta.env.VITE_OPERATOR_URL as string | undefined) ||
    (import.meta.env.DEV ? '/operator.html' : 'https://platform-admin.sentrysolutions.info');
  if (base.endsWith('.html')) return base;
  return path ? base.replace(/\/$/, '') + path : base;
}
